// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"SideBarComponent_sideBar__3zSvP","navigationMenu":"SideBarComponent_navigationMenu__dmgO4","navItemContainer":"SideBarComponent_navItemContainer__25UBw"};